<template>
  <div v-if="!isMobile" class="relative w-full h-64">
    <div
      v-for="(slide, index) in slides"
      :key="index"
      class="h-64"
      :class="[
        'absolute inset-0 u-center transition-opacity duration-500',
        slide.backgroundClass,
        { 'opacity-0': index !== currentIndex, 'opacity-100': index === currentIndex },
      ]"
    >
      <div :key="slide.name" class="flex items-center w-full h-full z-3 mx-auto max-w-[1100px]">
        <div class="flex flex-col self-end mb-6 gap-13">
          <div class="flex items-center absolute top-9">
            <!-- Logo -->
            <OImage src="/images/game/oyunLogo.png" alt="Logo" class="w-[173px] h-[68px] justify-start" />
            <p
              v-if="slide.name === 'oyun'"
              class="bg-[#3B2289] h-[46px] rounded-[5px] u-center px-4 py-2 text-white text-20 leading-normal ml-4"
            >
              Zaman Yolculuğuna Çık
            </p>
            <div v-else class="u-center text-white gap-2.5 ml-4">
              <p class="text-24 font-medium leading-normal">GenAI</p>
              <p class="w-[45px] h-[22px] p-2 u-center border border-white rounded-[3px] text-sm font-bold leading-18 ml-[10px]">Yeni</p>
            </div>
          </div>
          <div class="flex gap-5">
            <div class="flex flex-col gap-3.5">
              <p
                class="text-white text-30 font-bold leading-normal"
                :class="{ 'text-[#FFEEB4]': slide.name === 'heykel' }"
                v-html="slide.description"
              ></p>
              <p v-if="slide.name === 'heykel'" class="text-20 font-normal leading-26 text-white">
                {{ slide.subtext }}
              </p>
            </div>

            <OButton color-scheme="green" :href="slide.buttonHref" class="!p-2 mx-auto mt-auto rounded-md">
              <OImage loading="lazy" src="/images/game/arrow-left.png" class="w-6 h-6" />
            </OButton>
          </div>
        </div>
        <!-- photos -->
        <OImage v-if="slide.name === 'oyun'" loading="lazy" src="/images/game/games-masthead.png" class="w-[457px] h-[246px]" />
        <div v-else-if="slide.name === 'cumhuriyet'" class="flex">
          <OImage loading="lazy" src="/images/game/101_ozel.png" class="w-[156px] h-[117px]" />
          <OImage loading="lazy" src="/images/game/101_ozel_tablo.png" class="" />
        </div>
        <div v-else-if="slide.name === 'heykel'" class="flex">
          <OImage loading="lazy" src="/images/game/AI_heykel.png" />
          <OImage loading="lazy" src="/images/game/heykel_yildiz.png" class="w-[84px] h-20" />
        </div>
      </div>
    </div>
    <!-- Progress Bar -->
    <OProgress :timeout="5000" class="bg-[#BCBCBC] h-1.5" fill-color="#FFBD0C" @handleNext="nextSection" />
  </div>
  <div v-else class="relative h-[206px] w-full">
    <div
      v-for="(slide, index) in slides"
      :key="index"
      class="h-full"
      :class="[
        'absolute inset-0 u-center transition-opacity duration-500',
        slide.backgroundClass,
        { 'opacity-0': index !== currentIndex, 'opacity-100': index === currentIndex },
      ]"
    >
      <div :key="slide.name" class="flex items-center w-full h-full z-3 mx-auto pl-7">
        <div class="flex flex-col self-end mb-6 gap-13">
          <div class="flex items-center absolute top-4">
            <!-- Logo -->
            <OImage src="/images/game/oyunLogo.png" alt="Logo" class="w-[114px] h-[45px] justify-start" />
            <p
              v-if="slide.name === 'oyun'"
              class="bg-[#3B2289] rounded-[3px] u-center px-2.5 py-[5px] text-white text-base font-medium leading-normal ml-1.5"
            >
              Zaman Yolculuğuna Çık
            </p>
            <div v-else class="u-center text-white gap-2 px-2 py-1.5 ml-1.5">
              <p class="text-base font-medium leading-normal h-5">GenAI</p>
              <p class="h-4 p-1.5 u-center border border-white rounded-sm text-sm font-bold leading-18">Yeni</p>
            </div>
          </div>
          <div class="flex flex-col gap-3 items-start">
            <p
              class="text-white text-md font-bold leading-normal w-[185px]"
              :class="{ 'text-[#FFEEB4]': slide.name === 'heykel' }"
              v-html="slide.description"
            ></p>

            <!-- Buton -->
            <OButton color-scheme="green" :href="slide.buttonHref" class="u-center !py-2 !px-1.5 rounded-md text-white gap-1.5 h-7">
              <p class="text-xs font-semibold leading-16">{{ slide.buttonText }}</p>
              <OImage loading="lazy" src="/images/game/arrow-left.png" class="w-4 h-4" />
            </OButton>
          </div>
        </div>
        <!-- photos -->
        <OImage
          v-if="slide.name === 'oyun'"
          loading="lazy"
          src="/images/game/games-mobile-masthead.png"
          class="absolute w-[185px] h-[160px] bottom-0 right-0"
        />
        <div v-else-if="slide.name === 'cumhuriyet'" class="flex flex-col">
          <OImage loading="lazy" src="/images/game/101_ozel.png" class="self-end w-[63px] h-[63px]" />
          <OImage loading="lazy" src="/images/game/101_ozel_tablo.png" class="w-[137px] h-[120px]" />
        </div>
        <div v-else-if="slide.name === 'heykel'" class="flex flex-col mb-auto mt-4 w-full">
          <OImage loading="lazy" src="/images/game/heykel_yildiz.png" class="self-end w-9 h-9 mr-2" />
          <div class="absolute top-10">
            <OImage loading="lazy" src="/images/game/AI_heykel_mobile.png" />
            <OImage loading="lazy" src="/images/game/heykel_arrow.png" class="w-12 h-3 absolute top-2.5 left-[52px]" />
          </div>
        </div>
      </div>
    </div>
    <!-- Progress Bar -->
    <OProgress :timeout="5000" class="bg-[#BCBCBC] h-1.5" fill-color="#FFBD0C" @handleNext="nextSection" />
  </div>
</template>

<script>
import { defineComponent, ref } from '@nuxtjs/composition-api';
import { useDevice } from '~/composables/useDevice';
import { OButton, OImage, OIcon, OProgress } from '~/modules/common/components/ui';
export default defineComponent({
  components: { OButton, OImage, OIcon, OProgress },
  setup() {
    const { isMobile } = useDevice();

    const currentIndex = ref(0); // Varsayılan aktif slide

    const slides = [
      {
        name: 'oyun',
        backgroundClass: 'oyunBackground',
        title: 'Zaman Yolculuğuna Çık!',
        description: 'Artık Emojile ve Bilpop’un <br/> geçmiş oyunlarını oynayabilirsin!',
        buttonText: 'Geçmiş Oyunları Oyna',
        buttonHref: 'oyun/skor/emojile',
      },
    ];

    const nextSection = () => {
      currentIndex.value = (currentIndex.value + 1) % slides.length;
    };

    return { isMobile, slides, currentIndex, nextSection };
  },
});
</script>
<style lang="scss">
.oyunBackground {
  background: linear-gradient(-268deg, #00084d -12.87%, #5c1fa3 104.3%);
}

.cumhuriyetBackground {
  background: url('https://srv-cdn.onedio.com/store/6e68718d4e748d2ace366aa9add41a4e499837949e1f540fd2f8ebb920fb2585.png') no-repeat;
  background-size: cover;
  overflow: hidden auto;

  @media screen and (max-width: 480px) {
    background: url('https://srv-cdn.onedio.com/store/a69692ed5dab0294b73387c35fe6357aab1b76d29edc96655d13e80f0e2a0722.png') no-repeat;
    background-size: cover;
  }
}
.heykelBackground {
  background: url('https://srv-cdn.onedio.com/store/32861f2786a2fdfc4f4b366095614eb8b76902b189ee7f36d5dc0694a85403a9.png') no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 100%;
}
</style>
